/*
 * @Author: Tahiti
 * @Date: 2025-11-04 11:28:52
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-26 11:40:20
 * @Description:
 * @FilePath: /weryai-web/locales/modules/batchTools.ts
 */
export default {
    zh: {
        batchGenerate: '多模型批量',
        singleImgEdit: '逐张生成',
        all: '全部',
        threeDays: '最近三天',
        onWeek: '最近一周',
        oneMonth: '最近一个月',
        time: '时间',
        actions: '操作类型',
        IMAGE: '图片',
        VIDEO: '视频',
        AUDIO: '音乐',
        TOOL: '工具',
        copySuccess: '复制成功',
        placeholderName: '请输入项目名称',
        addProject: '新增项目',
        editProject: '编辑项目',
        confirm: '确定',
        cancel: '取消',
        deleteConfirmTitle: '确定删除该项目吗？',
        deleteConfirmMessage: '删除后已生成的记录将不会保留',
        publicVisibility: '公开可见',
        copyrightProtection: '版权保护',
        publicVisibilityTooltip:
            '开启此选项后， WeryAI可能会选中你的作品并将其发布到社区目录。',
        copyrightProtectionTooltip:
            '保护您的上传图片、视频和提示词不被展示在社区中。一旦启用此选项，其他WeryAI用户将无法在社区中看到您为生成此内容上传的图片、视频和提示词。',
        select: '选择',
        selectAll: '全选',
        delete: '删除',
        download: '下载',
        noMoreData: '没有更多数据了',
        noImage: '没有图片',
        generateFailed: '生成失败',
        selectMax: '最多选择 {count} 张图片',
        regenerate: '再次生成',
        selectModelLimitExceeded: '最多只能选择 {maxCount} 个模型',
        batchGenerateTooltip:
            '开启批量模式后，您可以同时选择多个模型生成图片。输出图片数量为每个模型输出的数量，例：选择4个模型和输出4张，会一次性为您生成16张图片',
        pleaseWaiting: '生成中...',
        allTime: '全部时间',
        allType: '全部类型',
        noImageSelected: '请选择图片',
        downloading: '下载中...',
        downloadFailed: '下载失败',
        downloadSuccess: '下载成功',
        downloadPartialSuccess:
            '下载部分成功，成功 {success} 张，失败 {total} 张',
        backToBottom: '回到底部',
        standardMode: '标准模式',
        standardDesc: '常规的生图流程',
        batchMode: '模型对比',
        batchGenerateDesc: '支持选多个模型生成，对比不同模型在相同参数的效果',
        singleMode: '多图批量',
        singleImgEditDesc: '将当前提示词及设定批量用到上传的参考图中',
        singleImgReference: '单图参考',
        multiImgReference: '多图参考',
        firstAndEndFrame: '首尾帧',
        firstFrame: '首帧',
        endFrame: '尾帧',
        creativeDescription: '创意描述',
        deleteSuccess: '删除成功',
        deleteTitle: '此操作将永久删除{total}个文件，是否继续？',
        deleteCancel: '取消',
        deleteConfirm: '确定',
        deleteAll: '删除全部',
        downloadAll: '下载全部',
        noContent: '没有可下载的内容',
        pleaseSelectImage: '请选择要删除的素材',
        pleaseChooseSame: '请选择同一条记录里要删除的素材',
        confirmDelete: '确认删除',
        noRecommend: '暂无推荐',
        apply: '应用',
        // MusicHistoryCard 相关
        prompt: '提示词',
        noPrompt: '暂无提示词',
        lyrics: '歌词',
        noLyrics: '暂无歌词',
        downloadCover: '下载封面',
        downloadMusic: '下载音乐',
        untitledMusic: '未命名音乐',
        noPlayableAudio: '暂无可播放的音频',
        noCopyContent: '暂无内容可复制',
        copyFailed: '复制失败',
        noDownloadableCover: '暂无可下载的封面',
        preparingDownload: '正在准备下载...',
        downloadRetry: '下载失败，请稍后重试',
        noDownloadableAudio: '暂无可下载的音频',
        selectMaxVideo: '最多选择 {count} 个视频',
    },
    en: {
        batchGenerate: 'Multi-model Batch',
        singleImgEdit: 'Single Image Edit',
        all: 'All',
        threeDays: 'Last 3 Days',
        onWeek: 'Last Week',
        oneMonth: 'Last Month',
        time: 'Time',
        actions: 'Actions Type',
        IMAGE: 'Image',
        VIDEO: 'Video',
        AUDIO: 'Music',
        TOOL: 'Tool',
        copySuccess: 'Copy Success',
        placeholderName: 'Please enter the project name',
        addProject: 'Add Project',
        editProject: 'Edit Project',
        confirm: 'Confirm',
        cancel: 'Cancel',
        deleteConfirmTitle: 'Are you sure you want to delete this project?',
        deleteConfirmMessage:
            'Generated records will not be retained after deletion',
        publicVisibility: 'Public Visibility',
        copyrightProtection: 'Copyright Protection',
        publicVisibilityTooltip:
            'By enabling this option, 微鲤AI may select your works and publish it to the community directory.',
        copyrightProtectionTooltip:
            'Protect your uploaded images, videos and prompts from being displayed in the community. Once enabled, other 微鲤AI users will not be able to see the images, videos, and prompts you uploaded to generate this content in the community.',
        select: 'Select',
        selectAll: 'Select All',
        delete: 'Delete',
        download: 'Download',
        noMoreData: 'No more data',
        noImage: 'No image',
        generateFailed: 'Generate Failed',
        selectMax: 'Select up to {count} images',
        regenerate: 'Regenerate',
        selectModelLimitExceeded: 'You can select up to {maxCount} models',
        batchGenerateTooltip:
            'By enabling batch mode, you can select multiple models to generate images at the same time. The output image number is the number of images output by each model, for example: selecting 4 models and outputting 4 images, it will generate 16 images for you at once',
        pleaseWaiting: 'Generating...',
        allTime: 'All Time',
        allType: 'All Type',
        noImageSelected: 'Please select images',
        downloading: 'Downloading...',
        downloadFailed: 'Download failed',
        downloadSuccess: 'Download successful',
        downloadPartialSuccess:
            'Partial download success, {success} successful, {total} failed',
        backToBottom: 'Back to Bottom',
        standardMode: 'Standard Mode',
        standardDesc: 'Regular image generation process',
        batchMode: 'Model Comparison',
        batchGenerateDesc:
            'Support selecting multiple models to generate, comparing the effects of different models with the same parameters',
        singleMode: 'Multi-image Batch',
        singleImgEditDesc:
            'Use the current prompt and settings to batch upload the reference images',
        singleImgReference: 'Single Image Reference',
        multiImgReference: 'Multi Image Reference',
        firstAndEndFrame: 'First and End Frame',
        firstFrame: 'First Frame',
        endFrame: 'End Frame',
        creativeDescription: 'Creative Description',
        deleteSuccess: 'Delete Success',
        deleteTitle:
            'This operation will permanently delete {total} files, are you sure?',
        deleteCancel: 'Cancel',
        deleteConfirm: 'Confirm',
        deleteAll: 'Delete All',
        downloadAll: 'Download All',
        noContent: 'No content to download',
        pleaseSelectImage: 'Please select the material to delete',
        pleaseChooseSame:
            'Please select the material to delete in the same record',
        confirmDelete: 'Confirm Delete',
        noRecommend: 'No recommendations found',
        apply: 'Apply',
        // MusicHistoryCard related
        prompt: 'Prompt',
        noPrompt: 'No prompt',
        lyrics: 'Lyrics',
        noLyrics: 'No lyrics',
        downloadCover: 'Download Cover',
        downloadMusic: 'Download Music',
        untitledMusic: 'Untitled Music',
        noPlayableAudio: 'No playable audio',
        noCopyContent: 'No content to copy',
        copyFailed: 'Copy failed',
        noDownloadableCover: 'No downloadable cover',
        preparingDownload: 'Preparing download...',
        downloadRetry: 'Download failed, please try again',
        noDownloadableAudio: 'No downloadable audio',
        selectMaxVideo: 'Select up to {count} videos',
    },
    es: {
        batchGenerate: 'Lote Multi-modelo',
        singleImgEdit: 'Edición de Imagen Única',
        all: 'Todos',
        threeDays: 'Últimos 3 Días',
        onWeek: 'Última Semana',
        oneMonth: 'Último Mes',
        time: 'Tiempo',
        actions: 'Tipo de Acciones',
        IMAGE: 'Imagen',
        VIDEO: 'Video',
        AUDIO: 'Música',
        TOOL: 'Herramienta',
        copySuccess: 'Copiar éxito',
        placeholderName: 'Por favor ingrese el nombre del proyecto',
        addProject: 'Agregar Proyecto',
        editProject: 'Editar Proyecto',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        deleteConfirmTitle: '¿Está seguro de querer eliminar este proyecto?',
        deleteConfirmMessage:
            'Los registros generados no se conservarán después de la eliminación',
        publicVisibility: 'Visibilidad Pública',
        copyrightProtection: 'Protección de Copyright',
        publicVisibilityTooltip:
            'Al habilitar esta opción, 微鲤AI puede seleccionar su obra y publicarlo en el directorio de la comunidad.',
        copyrightProtectionTooltip:
            'Protege tus imágenes, videos y sugerencias cargados de ser mostrados en la comunidad. Una vez habilitado, otros usuarios de 微鲤AI no podrán ver las imágenes, videos y sugerencias que cargó para generar este contenido en la comunidad.',
        select: 'Seleccionar',
        selectAll: 'Seleccionar Todo',
        delete: 'Eliminar',
        download: 'Descargar',
        noMoreData: 'No hay más datos',
        noImage: 'No imagen',
        generateFailed: 'Generar Fallido',
        selectMax: 'Seleccionar hasta {count} imágenes',
        regenerate: 'Regenerar',
        selectModelLimitExceeded: 'Puedes seleccionar hasta {maxCount} modelos',
        batchGenerateTooltip:
            'Al habilitar el modo de lote, puede seleccionar varios modelos para generar imágenes al mismo tiempo. El número de imágenes de salida es el número de imágenes generadas por cada modelo, por ejemplo: seleccionar 4 modelos y generar 4 imágenes, generará 16 imágenes para usted a la vez',
        pleaseWaiting: 'Generando...',
        allTime: 'Todos los Tiempos',
        allType: 'Todos los Tipos',
        noImageSelected: 'Por favor seleccione imágenes',
        downloading: 'Descargando...',
        downloadFailed: 'Descarga fallida',
        downloadSuccess: 'Descarga exitosa',
        downloadPartialSuccess:
            'Descarga parcialmente exitosa, {success} exitosas, {total} fallidas',
        backToBottom: 'Volver al Final',
        standardMode: 'Modo Estándar',
        standardDesc: 'Proceso de generación de imágenes regular',
        batchMode: 'Comparación de Modelos',
        batchGenerateDesc:
            'Soporta seleccionar varios modelos para generar, comparando los efectos de diferentes modelos con los mismos parámetros',
        singleMode: 'Lote de Imágenes Múltiples',
        singleImgEditDesc:
            'Usar el prompt y las configuraciones actuales para generar imágenes en lote',
        singleImgReference: 'Referencia de Imagen Única',
        multiImgReference: 'Referencia de Imágenes Múltiples',
        firstAndEndFrame: 'Primer y Último Frame',
        firstFrame: 'Primer Frame',
        endFrame: 'Último Frame',
        creativeDescription: 'Descripción Creativa',
        deleteSuccess: 'Eliminar Exitoso',
        deleteTitle:
            'Esta operación eliminará permanentemente {total} archivos, ¿está seguro?',
        deleteCancel: 'Cancelar',
        deleteConfirm: 'Confirmar',
        deleteAll: 'Eliminar Todo',
        downloadAll: 'Descargar Todo',
        noContent: 'No hay contenido para descargar',
        pleaseSelectImage: 'Por favor seleccione el material a eliminar',
        pleaseChooseSame:
            'Por favor seleccione el material a eliminar en el mismo registro',
        confirmDelete: 'Confirmar Eliminación',
        noRecommend: 'No hay recomendaciones encontradas',
        apply: 'Aplicar',
        // MusicHistoryCard relacionado
        prompt: 'Prompt',
        noPrompt: 'Sin prompt',
        lyrics: 'Letra',
        noLyrics: 'Sin letra',
        downloadCover: 'Descargar Portada',
        downloadMusic: 'Descargar Música',
        untitledMusic: 'Música sin título',
        noPlayableAudio: 'Sin audio reproducible',
        noCopyContent: 'Sin contenido para copiar',
        copyFailed: 'Error al copiar',
        noDownloadableCover: 'Sin portada descargable',
        preparingDownload: 'Preparando descarga...',
        downloadRetry: 'Error de descarga, intente de nuevo',
        noDownloadableAudio: 'Sin audio descargable',
        selectMaxVideo: 'Seleccionar hasta {count} videos',
    },
    fr: {
        batchGenerate: 'Lot Multi-modèle',
        singleImgEdit: "Modification d'Image Unique",
        all: 'Tous',
        threeDays: 'Derniers 3 Jours',
        onWeek: 'Dernière Semaine',
        oneMonth: 'Dernier Mois',
        time: 'Temps',
        actions: "Type d'Actions",
        IMAGE: 'Image',
        VIDEO: 'Video',
        AUDIO: 'Musique',
        TOOL: 'Herramienta',
        copySuccess: 'Copie avec succès',
        placeholderName: 'Veuillez entrer le nom du projet',
        addProject: 'Ajouter un Projet',
        editProject: 'Modifier le Projet',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        deleteConfirmTitle: 'Êtes-vous sûr de vouloir supprimer ce projet ?',
        deleteConfirmMessage:
            'Les enregistrements générés ne seront pas conservés après la suppression',
        publicVisibility: 'Visibilité Publique',
        copyrightProtection: 'Protection de Copyright',
        publicVisibilityTooltip:
            'En activant cette option, 微鲤AI peut sélectionner votre obra et la publier dans le répertoire communautaire.',
        copyrightProtectionTooltip:
            "Protège vos images, vidéos et suggestions chargés de ne pas être affichés dans la communauté. Une fois activé, d'autres utilisateurs de 微鲤AI ne pourront pas voir les images, vidéos et suggestions que vous avez chargé pour générer ce contenu dans la communauté.",
        select: 'Sélectionner',
        selectAll: 'Sélectionner Tout',
        delete: 'Supprimer',
        download: 'Télécharger',
        noMoreData: 'Pas de données supplémentaires',
        noImage: 'Aucune image',
        generateFailed: 'Génération Échouée',
        selectMax: "Sélectionner jusqu'à {count} images",
        regenerate: 'Régénérer',
        selectModelLimitExceeded:
            "Vous pouvez sélectionner jusqu'à {maxCount} modèles",
        batchGenerateTooltip:
            "En activant le mode de lot, vous pouvez sélectionner plusieurs modèles pour générer des images en même temps. Le nombre d'images de sortie est le nombre d'images générées par chaque modèle, par exemple: sélectionner 4 modèles et générer 4 images, générera 16 images pour vous en même temps",
        pleaseWaiting: 'Génération...',
        allTime: 'Tous les Temps',
        allType: 'Tous les Types',
        noImageSelected: 'Veuillez sélectionner des images',
        downloading: 'Téléchargement...',
        downloadFailed: 'Échec du téléchargement',
        downloadSuccess: 'Téléchargement réussi',
        downloadPartialSuccess:
            'Téléchargement partiellement réussi, {success} réussis, {total} échoués',
        backToBottom: 'Retour en Bas',
        standardMode: 'Mode Standard',
        standardDesc: "Processus de génération d'images standard",
        batchMode: 'Comparaison de Modèles',
        batchGenerateDesc:
            'Supporte la sélection de plusieurs modèles pour générer, comparant les effets de différents modèles avec les mêmes paramètres',
        singleMode: 'Lot Multi-image',
        singleImgEditDesc:
            'Utiliser le prompt et les paramètres actuels pour générer des images en lot',
        singleImgReference: "Référence d'Image Unique",
        multiImgReference: "Référence d'Images Multiples",
        firstAndEndFrame: 'Premier et Dernier Frame',
        firstFrame: 'Premier Frame',
        endFrame: 'Dernier Frame',
        creativeDescription: 'Description Créative',
        deleteSuccess: 'Suppression Réussie',
        deleteTitle:
            'Cette opération supprimera définitivement {total} fichiers, êtes-vous sûr?',
        deleteCancel: 'Annuler',
        deleteConfirm: 'Confirmer',
        deleteAll: 'Supprimer Tout',
        downloadAll: 'Télécharger Tout',
        noContent: 'Aucun contenu à télécharger',
        pleaseSelectImage: 'Veuillez sélectionner le matériel à supprimer',
        pleaseChooseSame:
            'Veuillez sélectionner le matériel à supprimer dans le même enregistrement',
        confirmDelete: 'Confirmer la Suppression',
        noRecommend: 'Aucune recommandation trouvée',
        apply: 'Appliquer',
        // MusicHistoryCard lié
        prompt: 'Invite',
        noPrompt: 'Aucune invite',
        lyrics: 'Paroles',
        noLyrics: 'Aucune parole',
        downloadCover: 'Télécharger la Couverture',
        downloadMusic: 'Télécharger la Musique',
        untitledMusic: 'Musique sans titre',
        noPlayableAudio: 'Aucun audio lisible',
        noCopyContent: 'Aucun contenu à copier',
        copyFailed: 'Échec de la copie',
        noDownloadableCover: 'Aucune couverture téléchargeable',
        preparingDownload: 'Préparation du téléchargement...',
        downloadRetry: 'Échec du téléchargement, veuillez réessayer',
        noDownloadableAudio: 'Aucun audio téléchargeable',
        selectMaxVideo: "Sélectionner jusqu'à {count} vidéos",
        },
    ja: {
        batchGenerate: '多モデルバッチ',
        singleImgEdit: '単一画像編集',
        all: 'すべて',
        threeDays: '最近3日',
        onWeek: '最近1週間',
        oneMonth: '最近1ヶ月',
        time: '時間',
        actions: '操作タイプ',
        IMAGE: '画像',
        VIDEO: 'ビデオ',
        AUDIO: '音楽',
        TOOL: 'ツール',
        copySuccess: 'コピーに成功しました',
        placeholderName: 'プロジェクト名を入力してください',
        addProject: 'プロジェクトを追加',
        editProject: 'プロジェクトを編集',
        confirm: '確定',
        cancel: 'キャンセル',
        deleteConfirmTitle: 'このプロジェクトを削除してもよろしいですか？',
        deleteConfirmMessage: '削除後、生成されたレコードは保持されません',
        publicVisibility: '公開可見',
        copyrightProtection: '著作権保護',
        publicVisibilityTooltip:
            'このオプションを有効にすると、WeryAIはあなたの作品を選択してコミュニティディレクトリに公開することができます。',
        copyrightProtectionTooltip:
            '保護されたアップロード画像、ビデオとプロンプトは、コミュニティで表示されません。このオプションを有効にすると、他のWeryAIユーザーは、このコンテンツを生成するためにアップロードした画像、ビデオ、およびプロンプトをコミュニティで表示できなくなります。',
        select: '選択',
        selectAll: 'すべて選択',
        delete: '削除',
        download: 'ダウンロード',
        noMoreData: 'データがありません',
        noImage: '画像がありません',
        generateFailed: '生成失敗',
        selectMax: '最大 {count} 枚の画像を選択してください',
        regenerate: '再生成',
        selectModelLimitExceeded: '最大 {maxCount} 個のモデルを選択できます',
        batchGenerateTooltip:
            'バッチモードを有効にすると、複数のモデルを同時に選択して画像を生成できます。出力画像数は各モデルが生成する画像数で、例えば4つのモデルを選択して4つの画像を生成する場合、16枚の画像を一度に生成します',
        pleaseWaiting: '生成中...',
        allTime: 'すべての時間',
        allType: 'すべてのタイプ',
        noImageSelected: '画像を選択してください',
        downloading: 'ダウンロード中...',
        downloadFailed: 'ダウンロード失敗',
        downloadSuccess: 'ダウンロード成功',
        downloadPartialSuccess:
            '部分的なダウンロード成功、成功 {success} 枚、失敗 {total} 枚',
        backToBottom: '最後に戻る',
        standardMode: '標準モード',
        standardDesc: '標準的な画像生成プロセス',
        batchMode: 'モデル比較',
        batchGenerateDesc: '同じパラメータで異なるモデルの効果を比較できます',
        singleMode: '多枚画像生成',
        singleImgEditDesc:
            '現在のプロンプトと設定を使用して、参照画像に一括適用します',
        singleImgReference: '単一画像参照',
        multiImgReference: '複数画像参照',
        firstAndEndFrame: '最初と最後のフレーム',
        firstFrame: '最初のフレーム',
        endFrame: '最後のフレーム',
        creativeDescription: '創造的な説明',
        deleteSuccess: '削除成功',
        deleteTitle:
            'この操作は、{total}個のファイルを永久に削除します。続行しますか？',
        deleteCancel: 'キャンセル',
        deleteConfirm: '確定',
        deleteAll: 'すべて削除',
        downloadAll: 'すべてダウンロード',
        noContent: 'ダウンロードするコンテンツがありません',
        pleaseSelectImage: '削除する素材を選択してください',
        pleaseChooseSame: '同じレコード内で削除する素材を選択してください',
        confirmDelete: '削除を確認',
        noRecommend: '推薦が見つかりません',
        apply: '適用',
        // MusicHistoryCard 関連
        prompt: 'プロンプト',
        noPrompt: 'プロンプトなし',
        lyrics: '歌詞',
        noLyrics: '歌詞なし',
        downloadCover: 'カバーをダウンロード',
        downloadMusic: '音楽をダウンロード',
        untitledMusic: '無題の音楽',
        noPlayableAudio: '再生可能なオーディオがありません',
        noCopyContent: 'コピーするコンテンツがありません',
        copyFailed: 'コピーに失敗しました',
        noDownloadableCover: 'ダウンロード可能なカバーがありません',
        preparingDownload: 'ダウンロードを準備中...',
        downloadRetry: 'ダウンロードに失敗しました。もう一度お試しください',
        noDownloadableAudio: 'ダウンロード可能なオーディオがありません',
        selectMaxVideo: '最大 {count} 本の動画を選択できます',
    },
    ko: {
        batchGenerate: '다중 모델 배치',
        singleImgEdit: '단일 이미지 편집',
        all: '모두',
        threeDays: '최근 3일',
        onWeek: '최근 1주일',
        oneMonth: '최근 1개월',
        time: '시간',
        actions: '작업 유형',
        IMAGE: '이미지',
        VIDEO: '비디오',
        AUDIO: '음악',
        TOOL: '도구',
        copySuccess: '복사 성공',
        placeholderName: '프로젝트 이름을 입력하세요',
        addProject: '프로젝트 추가',
        editProject: '프로젝트 수정',
        confirm: '확인',
        cancel: '취소',
        deleteConfirmTitle:
            '이 프로젝트를 삭제하면 생성된 기록은 보관되지 않습니다',
        deleteConfirmMessage: '삭제 후 생성된 기록은 보관되지 않습니다',
        publicVisibility: '공개 가능',
        copyrightProtection: '저작권 보호',
        publicVisibilityTooltip:
            '이 옵션을 활성화하면 WeryAI가 작품을 선택하여 커뮤니티 디렉토리에 게시할 수 있습니다.',
        copyrightProtectionTooltip:
            '보호된 업로드 이미지, 비디오와 프롬프트는 커뮤니티에 표시되지 않습니다. 이 옵션을 활성화하면 다른 微鲤AI 사용자는 이 콘텐츠를 생성하기 위해 업로드한 이미지, 비디오, 프롬프트를 커뮤니티에서 볼 수 없게 됩니다.',
        select: '선택',
        selectAll: '모두 선택',
        delete: '삭제',
        download: '다운로드',
        noMoreData: '더 이상 데이터가 없습니다',
        noImage: '이미지가 없습니다',
        generateFailed: '생성 실패',
        selectMax: '최대 {count} 장의 이미지를 선택할 수 있습니다',
        regenerate: '다시 생성',
        selectModelLimitExceeded:
            '최대 {maxCount}개의 모델을 선택할 수 있습니다',
        batchGenerateTooltip:
            '배치 모드를 활성화하면 여러 모델을 동시에 선택하여 이미지를 생성할 수 있습니다. 출력 이미지 수는 각 모델이 생성하는 이미지 수입니다. 예를 들어, 4개의 모델을 선택하여 4개의 이미지를 생성하면 16장의 이미지를 한 번에 생성합니다',
        pleaseWaiting: '생성 중...',
        allTime: '모든 시간',
        allType: '모든 유형',
        noImageSelected: '이미지를 선택해주세요',
        downloading: '다운로드 중...',
        downloadFailed: '다운로드 실패',
        downloadSuccess: '다운로드 성공',
        downloadPartialSuccess:
            '부분 다운로드 성공, 성공 {success}장, 실패 {total}장',
        backToBottom: '맨 아래로',
        standardMode: '표준 모드',
        standardDesc: '표준적인 이미지 생성 프로세스',
        batchMode: '모델 비교',
        batchGenerateDesc:
            '동일한 파라미터로 다른 모델의 효과를 비교할 수 있습니다',
        singleMode: '다중 이미지 배치',
        singleImgEditDesc:
            '현재 프롬프트와 설정을 사용하여 참조 이미지에 일괄 적용합니다',
        singleImgReference: '단일 이미지 참조',
        multiImgReference: '다중 이미지 참조',
        firstAndEndFrame: '첫 번째와 마지막 프레임',
        firstFrame: '첫 번째 프레임',
        endFrame: '마지막 프레임',
        creativeDescription: '창의적 설명',
        deleteSuccess: '삭제 성공',
        deleteTitle:
            '이 작업은 {total}개의 파일을 영구적으로 삭제합니다. 계속하시겠습니까?',
        deleteCancel: '취소',
        deleteConfirm: '확인',
        deleteAll: '모두 삭제',
        downloadAll: '모두 다운로드',
        noContent: '다운로드할 콘텐츠가 없습니다',
        pleaseSelectImage: '삭제할 자료를 선택하세요',
        pleaseChooseSame: '동일한 레코드 내에서 삭제할 자료를 선택하세요',
        confirmDelete: '삭제 확인',
        noRecommend: '추천이 없습니다',
        apply: '적용',
        // MusicHistoryCard 관련
        prompt: '프롬프트',
        noPrompt: '프롬프트 없음',
        lyrics: '가사',
        noLyrics: '가사 없음',
        downloadCover: '커버 다운로드',
        downloadMusic: '음악 다운로드',
        untitledMusic: '제목 없는 음악',
        noPlayableAudio: '재생 가능한 오디오가 없습니다',
        noCopyContent: '복사할 콘텐츠가 없습니다',
        copyFailed: '복사 실패',
        noDownloadableCover: '다운로드 가능한 커버가 없습니다',
        preparingDownload: '다운로드 준비 중...',
        downloadRetry: '다운로드 실패, 다시 시도해 주세요',
        noDownloadableAudio: '다운로드 가능한 오디오가 없습니다',
        selectMaxVideo: '최대 {count}개의 동영상을 선택할 수 있습니다',
    },
    tw: {

        batchGenerate: '多模型批量',
        singleImgEdit: '逐张生成',
        all: '全部',
        threeDays: '最近三天',
        onWeek: '最近一周',
        oneMonth: '最近一个月',
        time: '时间',
        actions: '操作类型',
        IMAGE: '图片',
        VIDEO: '视频',
        AUDIO: '音乐',
        TOOL: '工具',
        copySuccess: '复制成功',
        placeholderName: '请输入项目名称',
        addProject: '新增项目',
        editProject: '编辑项目',
        confirm: '确定',
        cancel: '取消',
        deleteConfirmTitle: '确定删除该项目吗？',
        deleteConfirmMessage: '删除后已生成的记录将不会保留',
        publicVisibility: '公开可见',
        copyrightProtection: '版权保护',
        publicVisibilityTooltip:
            '开启此选项后， WeryAI可能会选中你的作品并将其发布到社区目录。',
        copyrightProtectionTooltip:
            '保护您的上传图片、视频和提示词不被展示在社区中。一旦启用此选项，其他WeryAI用户将无法在社区中看到您为生成此内容上传的图片、视频和提示词。',
        select: '选择',
        selectAll: '全选',
        delete: '删除',
        download: '下载',
        noMoreData: '没有更多数据了',
        noImage: '没有图片',
        generateFailed: '生成失败',
        selectMax: '最多选择 {count} 张图片',
        regenerate: '再次生成',
        selectModelLimitExceeded: '最多只能选择 {maxCount} 个模型',
        batchGenerateTooltip:
            '开启批量模式后，您可以同时选择多个模型生成图片。输出图片数量为每个模型输出的数量，例：选择4个模型和输出4张，会一次性为您生成16张图片',
        pleaseWaiting: '生成中...',
        allTime: '全部时间',
        allType: '全部类型',
        noImageSelected: '请选择图片',
        downloading: '下载中...',
        downloadFailed: '下载失败',
        downloadSuccess: '下载成功',
        downloadPartialSuccess:
            '下载部分成功，成功 {success} 张，失败 {total} 张',
        backToBottom: '回到底部',
        standardMode: '标准模式',
        standardDesc: '常规的生图流程',
        batchMode: '模型对比',
        batchGenerateDesc: '支持选多个模型生成，对比不同模型在相同参数的效果',
        singleMode: '多图批量',
        singleImgEditDesc: '将当前提示词及设定批量用到上传的参考图中',
        singleImgReference: '单图参考',
        multiImgReference: '多图参考',
        firstAndEndFrame: '首尾帧',
        firstFrame: '首帧',
        endFrame: '尾帧',
        creativeDescription: '创意描述',
        deleteSuccess: '删除成功',
        deleteTitle: '此操作将永久删除{total}个文件，是否继续？',
        deleteCancel: '取消',
        deleteConfirm: '确定',
        deleteAll: '删除全部',
        downloadAll: '下载全部',
        noContent: '没有可下载的内容',
        pleaseSelectImage: '请选择要删除的素材',
        pleaseChooseSame: '请选择同一条记录里要删除的素材',
        confirmDelete: '确认删除',
        noRecommend: '暂无推荐',
        apply: '应用',
        // MusicHistoryCard 相关
        prompt: '提示词',
        noPrompt: '暂无提示词',
        lyrics: '歌词',
        noLyrics: '暂无歌词',
        downloadCover: '下载封面',
        downloadMusic: '下载音乐',
        untitledMusic: '未命名音乐',
        noPlayableAudio: '暂无可播放的音频',
        noCopyContent: '暂无内容可复制',
        copyFailed: '复制失败',
        noDownloadableCover: '暂无可下载的封面',
        preparingDownload: '正在准备下载...',
        downloadRetry: '下载失败，请稍后重试',
        noDownloadableAudio: '暫無可下載的音訊',
        selectMaxVideo: '最多選擇 {count} 個影片',
    },
    pl: {

        batchGenerate: 'Multi-model Batch',
        singleImgEdit: 'Single Image Edit',
        all: 'All',
        threeDays: 'Last 3 Days',
        onWeek: 'Last Week',
        oneMonth: 'Last Month',
        time: 'Time',
        actions: 'Actions Type',
        IMAGE: 'Image',
        VIDEO: 'Video',
        AUDIO: 'Music',
        TOOL: 'Tool',
        copySuccess: 'Copy Success',
        placeholderName: 'Please enter the project name',
        addProject: 'Add Project',
        editProject: 'Edit Project',
        confirm: 'Confirm',
        cancel: 'Cancel',
        deleteConfirmTitle: 'Are you sure you want to delete this project?',
        deleteConfirmMessage:
            'Generated records will not be retained after deletion',
        publicVisibility: 'Public Visibility',
        copyrightProtection: 'Copyright Protection',
        publicVisibilityTooltip:
            'By enabling this option, 微鲤AI may select your works and publish it to the community directory.',
        copyrightProtectionTooltip:
            'Protect your uploaded images, videos and prompts from being displayed in the community. Once enabled, other 微鲤AI users will not be able to see the images, videos, and prompts you uploaded to generate this content in the community.',
        select: 'Select',
        selectAll: 'Select All',
        delete: 'Delete',
        download: 'Download',
        noMoreData: 'No more data',
        noImage: 'No image',
        generateFailed: 'Generate Failed',
        selectMax: 'Select up to {count} images',
        regenerate: 'Regenerate',
        selectModelLimitExceeded: 'You can select up to {maxCount} models',
        batchGenerateTooltip:
            'By enabling batch mode, you can select multiple models to generate images at the same time. The output image number is the number of images output by each model, for example: selecting 4 models and outputting 4 images, it will generate 16 images for you at once',
        pleaseWaiting: 'Generating...',
        allTime: 'All Time',
        allType: 'All Type',
        noImageSelected: 'Please select images',
        downloading: 'Downloading...',
        downloadFailed: 'Download failed',
        downloadSuccess: 'Download successful',
        downloadPartialSuccess:
            'Partial download success, {success} successful, {total} failed',
        backToBottom: 'Back to Bottom',
        standardMode: 'Standard Mode',
        standardDesc: 'Regular image generation process',
        batchMode: 'Model Comparison',
        batchGenerateDesc:
            'Support selecting multiple models to generate, comparing the effects of different models with the same parameters',
        singleMode: 'Multi-image Batch',
        singleImgEditDesc:
            'Use the current prompt and settings to batch upload the reference images',
        singleImgReference: 'Single Image Reference',
        multiImgReference: 'Multi Image Reference',
        firstAndEndFrame: 'First and End Frame',
        firstFrame: 'First Frame',
        endFrame: 'End Frame',
        creativeDescription: 'Creative Description',
        deleteSuccess: 'Delete Success',
        deleteTitle:
            'This operation will permanently delete {total} files, are you sure?',
        deleteCancel: 'Cancel',
        deleteConfirm: 'Confirm',
        deleteAll: 'Delete All',
        downloadAll: 'Download All',
        noContent: 'No content to download',
        pleaseSelectImage: 'Please select the material to delete',
        pleaseChooseSame:
            'Please select the material to delete in the same record',
        confirmDelete: 'Confirm Delete',
        noRecommend: 'No recommendations found',
        apply: 'Apply',
        // MusicHistoryCard related
        prompt: 'Prompt',
        noPrompt: 'No prompt',
        lyrics: 'Lyrics',
        noLyrics: 'No lyrics',
        downloadCover: 'Download Cover',
        downloadMusic: 'Download Music',
        untitledMusic: 'Untitled Music',
        noPlayableAudio: 'No playable audio',
        noCopyContent: 'No content to copy',
        copyFailed: 'Copy failed',
        noDownloadableCover: 'No downloadable cover',
        preparingDownload: 'Preparing download...',
        downloadRetry: 'Download failed, please try again',
        noDownloadableAudio: 'No downloadable audio',
        selectMaxVideo: 'Select up to {count} videos',
    },
    de: {
        batchGenerate: 'Multi-Modell-Batch',
        singleImgEdit: 'Einzelbild-Bearbeitung',
        all: 'Alle',
        threeDays: 'Letzte 3 Tage',
        onWeek: 'Letzte Woche',
        oneMonth: 'Letzter Monat',
        time: 'Zeit',
        actions: 'Aktionstyp',
        IMAGE: 'Bild',
        VIDEO: 'Video',
        AUDIO: 'Musik',
        TOOL: 'Werkzeug',
        copySuccess: 'Kopieren erfolgreich',
        placeholderName: 'Bitte geben Sie den Projektnamen ein',
        addProject: 'Projekt hinzufügen',
        editProject: 'Projekt bearbeiten',
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
        deleteConfirmTitle:
            'Sind Sie sicher, dass Sie dieses Projekt löschen möchten?',
        deleteConfirmMessage:
            'Generierte Datensätze werden nach dem Löschen nicht gespeichert',
        publicVisibility: 'Öffentliche Sichtbarkeit',
        copyrightProtection: 'Copyright-Schutz',
        publicVisibilityTooltip:
            'Durch Aktivieren dieser Option kann 微鲤AI Ihre Werke auswählen und in das Community-Verzeichnis veröffentlichen.',
        copyrightProtectionTooltip:
            'Schützt Ihre hochgeladenen Bilder, Videos und Hinweise davor, in der Community angezeigt zu werden. Wenn diese Option aktiviert ist, können andere 微鲤AI-Benutzer in der Community nicht sehen, welche Bilder, Videos und Hinweise Sie hochgeladen haben, um diesen Inhalt zu generieren.',
        select: 'Auswählen',
        selectAll: 'Alle Auswählen',
        delete: 'Löschen',
        download: 'Herunterladen',
        noMoreData: 'Keine weiteren Daten',
        noImage: 'Keine Bild',
        generateFailed: 'Generierung Fehlgeschlagen',
        selectMax: 'Wählen Sie bis zu {count} Bilder',
        regenerate: 'Erneut generieren',
        selectModelLimitExceeded:
            'Sie können bis zu {maxCount} Modelle auswählen',
        batchGenerateTooltip:
            'Durch Aktivieren des Batch-Modus können Sie mehrere Modelle gleichzeitig auswählen und Bilder generieren. Die Anzahl der Ausgabebilder ist die Anzahl der Bilder, die jedes Modell generiert. Beispiel: Wenn Sie 4 Modelle auswählen und 4 Bilder generieren, generiert es 16 Bilder für Sie auf einmal',
        pleaseWaiting: 'Generieren...',
        allTime: 'Alle Zeiten',
        allType: 'Alle Typen',
        noImageSelected: 'Bitte wählen Sie Bilder aus',
        downloading: 'Herunterladen...',
        downloadFailed: 'Download fehlgeschlagen',
        downloadSuccess: 'Download erfolgreich',
        downloadPartialSuccess:
            'Teilweise erfolgreich, {success} erfolgreich, {total} fehlgeschlagen',
        backToBottom: 'Zurück zum Ende',
        standardMode: 'Standard-Modus',
        standardDesc: 'Standard-Bildgenerierungsprozess',
        batchMode: 'Modellvergleich',
        batchGenerateDesc:
            'Unterstützt das Auswählen mehrerer Modelle zur Generierung, um die Effekte verschiedener Modelle mit den gleichen Parametern zu vergleichen',
        singleMode: 'Mehrere Bildgenerierung',
        singleImgEditDesc:
            'Verwendet den aktuellen Prompt und die Einstellungen, um die Referenzbilder in Batch zu verwenden',
        singleImgReference: 'Einzelbild-Referenz',
        multiImgReference: 'Mehrere Bild-Referenzen',
        firstAndEndFrame: 'Erster und Letzter Frame',
        firstFrame: 'Erster Frame',
        endFrame: 'Letzter Frame',
        creativeDescription: 'Kreative Beschreibung',
        deleteSuccess: 'Löschen erfolgreich',
        deleteTitle:
            'Diese Operation löscht {total} Dateien dauerhaft. Fortfahren?',
        deleteCancel: 'Abbrechen',
        deleteConfirm: 'Bestätigen',
        deleteAll: 'Alle Löschen',
        downloadAll: 'Alle Herunterladen',
        noContent: 'Kein Inhalt zum Herunterladen',
        pleaseSelectImage: 'Bitte wählen Sie das Material zum Löschen aus',
        pleaseChooseSame:
            'Bitte wählen Sie das Material zum Löschen im selben Datensatz aus',
        confirmDelete: 'Löschen bestätigen',
        noRecommend: 'Keine Empfehlungen gefunden',
        apply: 'Anwenden',
        // MusicHistoryCard bezogen
        prompt: 'Eingabeaufforderung',
        noPrompt: 'Keine Eingabeaufforderung',
        lyrics: 'Liedtext',
        noLyrics: 'Kein Liedtext',
        downloadCover: 'Cover herunterladen',
        downloadMusic: 'Musik herunterladen',
        untitledMusic: 'Unbenannte Musik',
        noPlayableAudio: 'Kein abspielbares Audio',
        noCopyContent: 'Kein Inhalt zum Kopieren',
        copyFailed: 'Kopieren fehlgeschlagen',
        noDownloadableCover: 'Kein herunterladbares Cover',
        preparingDownload: 'Download wird vorbereitet...',
        downloadRetry: 'Download fehlgeschlagen, bitte erneut versuchen',
        noDownloadableAudio: 'Kein herunterladbares Audio',
        selectMaxVideo: 'Maximal {count} Videos auswählen',
    },
    it: {
        batchGenerate: 'Batch Multi-modello',
        singleImgEdit: 'Modifica Immagine Unica',
        all: 'Tutti',
        threeDays: 'Ultimi 3 Giorni',
        onWeek: 'Ultima Settimana',
        oneMonth: 'Ultimo Mese',
        time: 'Tempo',
        actions: 'Tipo di Azione',
        IMAGE: 'Immagine',
        VIDEO: 'Video',
        AUDIO: 'Musica',
        TOOL: 'Strumento',
        copySuccess: 'Copia riuscita',
        placeholderName: 'Inserisci il nome del progetto',
        addProject: 'Aggiungi Progetto',
        editProject: 'Modifica Progetto',
        confirm: 'Conferma',
        cancel: 'Annulla',
        deleteConfirmTitle: 'Sei sicuro di voler eliminare questo progetto?',
        deleteConfirmMessage:
            "I record generati non verranno conservati dopo l'eliminazione",
        publicVisibility: 'Visibilità Pubblica',
        copyrightProtection: 'Protezione di Copyright',
        publicVisibilityTooltip:
            'Abilitando questa opzione, 微鲤AI può selezionare il tuo lavoro e pubblicarlo nel catalogo della comunità.',
        copyrightProtectionTooltip:
            'Proteggi i tuoi immagini, video e suggerimenti caricati da non essere mostrati nella comunità. Una volta abilitato, altri utenti di 微鲤AI non potranno vedere le immagini, video e suggerimenti che hai caricato per generare questo contenuto nella comunità.',
        select: 'Selezionare',
        selectAll: 'Selezionare Tutto',
        delete: 'Elimina',
        download: 'Scaricare',
        noMoreData: 'Nessun dato disponibile',
        noImage: 'Nessuna immagine',
        generateFailed: 'Generazione Fallita',
        selectMax: 'Selezionare fino a {count} immagini',
        regenerate: 'Rimuovere',
        selectModelLimitExceeded: 'Puoi selezionare fino a {maxCount} modelli',
        batchGenerateTooltip:
            'Abilitando il modo batch, puoi selezionare più modelli per generare immagini contemporaneamente. Il numero di immagini di output è il numero di immagini generate da ogni modello, ad esempio: selezionando 4 modelli e generando 4 immagini, genera 16 immagini per te in una volta sola',
        pleaseWaiting: 'Generazione...',
        allTime: 'Tutti i Tempi',
        allType: 'Tutti i Tipi',
        noImageSelected: 'Seleziona le immagini',
        downloading: 'Scaricamento...',
        downloadFailed: 'Download fallito',
        downloadSuccess: 'Download riuscito',
        downloadPartialSuccess:
            'Download parzialmente riuscito, {success} riusciti, {total} falliti',
        backToBottom: "Ritorno all'ultimo",
        standardMode: 'Modalità Standard',
        standardDesc: 'Processo di generazione di immagini standard',
        batchMode: 'Confronto Modelli',
        batchGenerateDesc:
            'Supporta la selezione di più modelli per generare, confrontando gli effetti di differenti modelli con gli stessi parametri',
        singleMode: 'Generazione Multi-immagine',
        singleImgEditDesc:
            'Utilizza il prompt e le impostazioni correnti per generare immagini in batch',
        singleImgReference: 'Riferimento Immagine Unica',
        multiImgReference: 'Riferimento Immagini Multiple',
        firstAndEndFrame: 'Primo e Ultimo Frame',
        firstFrame: 'Primo Frame',
        endFrame: 'Ultimo Frame',
        creativeDescription: 'Descrizione Creativa',
        deleteSuccess: 'Eliminazione riuscita',
        deleteTitle:
            'Esta operação excluirá permanentemente {total} arquivos. Continuar?',
        deleteCancel: 'Cancelar',
        deleteConfirm: 'Confirmar',
        deleteAll: 'Todos os Excluir',
        downloadAll: 'Scarica Tutto',
        noContent: 'Nessun contenuto da scaricare',
        pleaseSelectImage: 'Seleziona il materiale da eliminare',
        pleaseChooseSame:
            'Seleziona il materiale da eliminare nella stessa registrazione',
        confirmDelete: 'Conferma eliminazione',
        noRecommend: 'Nessuna raccomandazione trovata',
        apply: 'Applicare',
        // MusicHistoryCard correlato
        prompt: 'Prompt',
        noPrompt: 'Nessun prompt',
        lyrics: 'Testo',
        noLyrics: 'Nessun testo',
        downloadCover: 'Scarica Copertina',
        downloadMusic: 'Scarica Musica',
        untitledMusic: 'Musica senza titolo',
        noPlayableAudio: 'Nessun audio riproducibile',
        noCopyContent: 'Nessun contenuto da copiare',
        copyFailed: 'Copia fallita',
        noDownloadableCover: 'Nessuna copertina scaricabile',
        preparingDownload: 'Preparazione download...',
        downloadRetry: 'Download fallito, riprova più tardi',
        noDownloadableAudio: 'Nessun audio scaricabile',
        selectMaxVideo: 'Seleziona fino a {count} video',
    },
    pt: {
        batchGenerate: 'Lote Multi-modelo',
        singleImgEdit: 'Edição de Imagem Única',
        all: 'Todos',
        threeDays: 'Últimos 3 Dias',
        onWeek: 'Última Semana',
        oneMonth: 'Último Mês',
        time: 'Tempo',
        actions: 'Tipo de Ação',
        IMAGE: 'Imagem',
        VIDEO: 'Vídeo',
        AUDIO: 'Música',
        TOOL: 'Ferramenta',
        copySuccess: 'Copiar com sucesso',
        placeholderName: 'Por favor, insira o nome do projeto',
        addProject: 'Adicionar Projeto',
        editProject: 'Editar Projeto',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        deleteConfirmTitle: 'Tem certeza de que deseja excluir este projeto?',
        deleteConfirmMessage:
            'Os registros gerados não serão mantidos após a exclusão',
        publicVisibility: 'Visibilidade Pública',
        copyrightProtection: 'Proteção de Copyright',
        publicVisibilityTooltip:
            'Ativando esta opção, 微鲤AI pode selecionar seu obra e publicá-lo no catálogo da comunidade.',
        copyrightProtectionTooltip:
            'Protege seus imagens, vídeos e sugestões carregados de não serem mostrados na comunidade. Uma vez ativado, outros usuários de 微鲤AI não poderão ver as imagens, vídeos e sugestões que você carregou para gerar este conteúdo na comunidade.',
        select: 'Selecionar',
        selectAll: 'Selecionar Tudo',
        delete: 'Excluir',
        download: 'Baixar',
        noMoreData: 'Nenhum dado disponível',
        noImage: 'Nenhuma imagem',
        generateFailed: 'Geração Falhada',
        selectMax: 'Selecionar até {count} imagens',
        regenerate: 'Regenerar',
        selectModelLimitExceeded:
            'Você pode selecionar até {maxCount} imagens ou vídeos',
        batchGenerateTooltip:
            'Ao habilitar o modo de lote, você pode selecionar vários modelos para gerar imagens ao mesmo tempo. O número de imagens de saída é o número de imagens geradas por cada modelo, por exemplo: selecionando 4 modelos e gerando 4 imagens, gera 16 imagens para você de uma vez só',
        pleaseWaiting: 'Gerando...',
        allTime: 'Todos os Tempos',
        allType: 'Todos os Tipos',
        noImageSelected: 'Por favor selecione imagens',
        downloading: 'Baixando...',
        downloadFailed: 'Download falhou',
        downloadSuccess: 'Download bem-sucedido',
        downloadPartialSuccess:
            'Download parcialmente bem-sucedido, {success} bem-sucedidos, {total} falharam',
        backToBottom: 'Voltar ao Final',
        standardMode: 'Modo Padrão',
        standardDesc: 'Processo de geração de imagens padrão',
        batchMode: 'Comparação de Modelos',
        batchGenerateDesc:
            'Suporta a seleção de vários modelos para gerar, comparando os efeitos de diferentes modelos com os mesmos parâmetros',
        singleMode: 'Gerar Múltiplas Imagens',
        singleImgEditDesc:
            'Utiliza o prompt e as configurações atuais para gerar imagens em lote',
        singleImgReference: 'Referência de Imagem Única',
        multiImgReference: 'Referência de Imagens Múltiplas',
        firstAndEndFrame: 'Primeiro e Último Frame',
        firstFrame: 'Primeiro Frame',
        endFrame: 'Último Frame',
        creativeDescription: 'Descrição Criativa',
        deleteSuccess: 'Exclusão bem-sucedida',
        deleteTitle:
            'Esta operação excluirá permanentemente o arquivo. Continuar?',
        deleteCancel: 'Cancelar',
        deleteConfirm: 'Confirmar',
        deleteAll: 'Todos os Excluir',
        downloadAll: 'Baixar Tudo',
        noContent: 'Nenhum conteúdo para baixar',
        pleaseSelectImage: 'Por favor, selecione o material para excluir',
        pleaseChooseSame:
            'Por favor, selecione o material para excluir na mesma entrada',
        confirmDelete: 'Confirmar exclusão',
        noRecommend: 'Nenhuma recomendação encontrada',
        apply: 'Aplicar',
        // MusicHistoryCard relacionado
        prompt: 'Prompt',
        noPrompt: 'Sem prompt',
        lyrics: 'Letra',
        noLyrics: 'Sem letra',
        downloadCover: 'Baixar Capa',
        downloadMusic: 'Baixar Música',
        untitledMusic: 'Música sem título',
        noPlayableAudio: 'Nenhum áudio reproduzível',
        noCopyContent: 'Nenhum conteúdo para copiar',
        copyFailed: 'Falha ao copiar',
        noDownloadableCover: 'Nenhuma capa disponível para download',
        preparingDownload: 'Preparando download...',
        downloadRetry: 'Falha no download, tente novamente',
        noDownloadableAudio: 'Nenhum áudio disponível para download',
        selectMaxVideo: 'Selecione até {count} vídeos',
    },
    ru: {
        batchGenerate: 'Пакет Многомодельный',
        singleImgEdit: 'Редактирование Одного Изображения',
        all: 'Все',
        threeDays: 'Последние 3 дня',
        onWeek: 'Последняя неделя',
        oneMonth: 'Последний месяц',
        time: 'Время',
        actions: 'Тип Действия',
        IMAGE: 'Изображение',
        VIDEO: 'Видео',
        AUDIO: 'Музыка',
        TOOL: 'Инструмент',
        copySuccess: 'Копировать успешно',
        placeholderName: 'Пожалуйста, введите название проекта',
        addProject: 'Добавить проект',
        editProject: 'Редактировать проект',
        confirm: 'Подтвердить',
        cancel: 'Отмена',
        deleteConfirmTitle: 'Вы уверены, что хотите удалить этот проект?',
        deleteConfirmMessage:
            'Сгенерированные записи не будут сохранены после удаления',
        publicVisibility: 'Публичная Видимость',
        copyrightProtection: 'Защита Авторских Прав',
        publicVisibilityTooltip:
            'Включив эту опцию, 微鲤AI может выбрать ваш obra и опубликовать его в каталоге сообщества.',
        copyrightProtectionTooltip:
            'Защищает ваши загруженные изображения, видео и подсказки от отображения в сообществе. После включения другие пользователи 微鲤AI не смогут видеть изображения, видео и подсказки, которые вы загрузили для генерации этого контента в сообществе.',
        select: 'Выбрать',
        selectAll: 'Выбрать Все',
        delete: 'Удалить',
        download: 'Скачать',
        noMoreData: 'Нет данных',
        noImage: 'Нет изображения',
        generateFailed: 'Генерация Неуспешна',
        selectMax: 'Выбрать до {count} изображений',
        regenerate: 'Повторно сгенерировать',
        selectModelLimitExceeded:
            'Вы можете выбрать до {maxCount} изображений или видео',
        batchGenerateTooltip:
            'Включив режим пакета, вы можете выбрать несколько моделей для одновременного генерации изображений. Количество выходных изображений равно количеству изображений, генерируемых каждой моделью, например: выбрав 4 модели и выбрав 4 изображения, генерирует 16 изображений для вас одновременно',
        pleaseWaiting: 'Генерация...',
        allTime: 'Все Времена',
        allType: 'Все Типы',
        noImageSelected: 'Пожалуйста, выберите изображения',
        downloading: 'Загрузка...',
        downloadFailed: 'Загрузка не удалась',
        downloadSuccess: 'Загрузка успешна',
        downloadPartialSuccess:
            'Частично успешная загрузка, {success} успешных, {total} неудачных',
        backToBottom: 'Вернуться к концу',
        standardMode: 'Стандартный режим',
        standardDesc: 'Стандартный процесс генерации изображений',
        batchMode: 'Сравнение моделей',
        batchGenerateDesc:
            'Поддерживает выбор нескольких моделей для генерации, сравнивая эффекты различных моделей с одними и теми же параметрами',
        singleMode: 'Генерация множества изображений',
        singleImgEditDesc:
            'Использует текущий промпт и настройки для генерации изображений в пакетном режиме',
        singleImgReference: 'Ссылка на Одно изображение',
        multiImgReference: 'Ссылка на Несколько изображений',
        firstAndEndFrame: 'Первый и Последний Frame',
        firstFrame: 'Первый Frame',
        endFrame: 'Последний Frame',
        creativeDescription: 'Творческое описание',
        deleteSuccess: 'Удаление успешно',
        deleteTitle: 'Эта операция удалит файл навсегда. Продолжить?',
        deleteCancel: 'Отмена',
        deleteConfirm: 'Подтвердить',
        deleteAll: 'Удалить Все',
        downloadAll: 'Скачать Все',
        noContent: 'Нет контента для скачивания',
        pleaseSelectImage: 'Пожалуйста, выберите материал для удаления',
        pleaseChooseSame:
            'Пожалуйста, выберите материал для удаления в той же записи',
        confirmDelete: 'Подтвердить удаление',
        noRecommend: 'Рекомендаций не найдено',
        apply: 'Применить',
        // MusicHistoryCard связанные
        prompt: 'Подсказка',
        noPrompt: 'Нет подсказки',
        lyrics: 'Текст песни',
        noLyrics: 'Нет текста песни',
        downloadCover: 'Скачать обложку',
        downloadMusic: 'Скачать музыку',
        untitledMusic: 'Без названия',
        noPlayableAudio: 'Нет воспроизводимого аудио',
        noCopyContent: 'Нет содержимого для копирования',
        copyFailed: 'Ошибка копирования',
        noDownloadableCover: 'Нет доступной обложки для скачивания',
        preparingDownload: 'Подготовка к загрузке...',
        downloadRetry: 'Ошибка загрузки, попробуйте снова',
        noDownloadableAudio: 'Нет доступного аудио для скачивания',
        selectMaxVideo: 'Выберите до {count} видео',
    },
    ar: {
        batchGenerate: 'دفعة متعددة النماذج',
        singleImgEdit: 'تحرير صورة واحدة',
        all: 'كل',
        threeDays: 'آخر 3 أيام',
        onWeek: 'آخر أسبوع',
        oneMonth: 'آخر شهر',
        time: 'وقت',
        actions: 'نوع العملية',
        IMAGE: 'صورة',
        VIDEO: 'فيديو',
        AUDIO: 'موسيقى',
        TOOL: 'أداة',
        copySuccess: 'تم النسخ',
        placeholderName: 'الرجاء إدخال اسم المشروع',
        addProject: 'إضافة مشروع',
        editProject: 'تعديل المشروع',
        confirm: 'تأكيد',
        cancel: 'إلغاء',
        deleteConfirmTitle: 'هل أنت متأكد من حذف هذا المشروع؟',
        deleteConfirmMessage: 'لن يتم الاحتفاظ بالسجلات المُنشأة بعد الحذف',
        publicVisibility: 'الرؤية العامة',
        copyrightProtection: 'حماية الحقوق الفكرية',
        publicVisibilityTooltip:
            'بتفعيل هذه الخيار، يمكن لـ 微鲤AI تحديد العمل الخاص بك ونشره في قائمة المجتمع.',
        copyrightProtectionTooltip:
            'يحمي الصور والفيديوهات والتلميحات التي تم تحميلها من عرضها في المجتمع. بمجرد تفعيل هذا الخيار، لن يتمكن المستخدمون الآخرون من 微鲤AI من رؤية الصور والفيديوهات والتلميحات التي قمت بتحميلها لإنشاء هذا المحتوى في المجتمع.',
        select: 'اختيار',
        selectAll: 'اختيار كل',
        delete: 'حذف',
        download: 'تحميل',
        noMoreData: 'لا يوجد بيانات',
        noImage: 'لا يوجد صورة',
        generateFailed: 'توليد فشل',
        selectMax: 'اختر حتى {count} صورة',
        regenerate: 'إعادة التوليد',
        selectModelLimitExceeded: 'يمكنك تحديد حتى {maxCount} صورة أو فيديو',
        batchGenerateTooltip:
            'بتفعيل وضع الحزمة، يمكنك تحديد عدة أنماط لتوليد الصور في نفس الوقت. عدد الصور المخرجة هو عدد الصور التي تم إنشاؤها من كل نمط، على سبيل المثال: إذا قمت بتحديد 4 أنماط وإنشاء 4 صور، فسيتم إنشاء 16 صورة لك في وقت واحد',
        pleaseWaiting: 'توليد...',
        allTime: 'كل الأوقات',
        allType: 'كل الأنواع',
        noImageSelected: 'الرجاء اختيار الصور',
        downloading: 'جارٍ التحميل...',
        downloadFailed: 'فشل التحميل',
        downloadSuccess: 'تم التحميل بنجاح',
        downloadPartialSuccess: 'تم التحميل جزئياً، نجح {success}، فشل {total}',
        backToBottom: 'العودة إلى النهاية',
        standardMode: 'الوضع القياسي',
        standardDesc: 'عملية التوليد القياسية للصور',
        batchMode: 'مقارنة النماذج',
        batchGenerateDesc:
            'يدعم اختيار عدة أنماع لتوليد الصور في نفس الوقت، مقارنة الأثر النمطي للأنماط المختلفة بنفس المعاملات',
        singleMode: 'توليد عدة صور',
        singleImgEditDesc:
            'يستخدم البرمجية الحالية والإعدادات لتوليد الصور في وضع الحزمة',
        singleImgReference: 'الرابط على صورة واحدة',
        multiImgReference: 'الرابط على عدة صور',
        firstAndEndFrame: 'الأول والأخير في الفيديو',
        firstFrame: 'الأول في الفيديو',
        endFrame: 'الأخير في الفيديو',
        creativeDescription: 'وصف تصويري',
        deleteSuccess: 'حذف ناجح',
        deleteTitle: 'هذه العملية ستحذف {total} ملف نهائياً. المتابعة؟',
        deleteCancel: 'إلغاء',
        deleteConfirm: 'تأكيد',
        deleteAll: 'حذف كل',
        downloadAll: 'تحميل الكل',
        noContent: 'لا يوجد محتوى للتحميل',
        pleaseSelectImage: 'الرجاء اختيار المادة للحذف',
        pleaseChooseSame: 'الرجاء اختيار المادة للحذف في نفس السجل',
        confirmDelete: 'تأكيد الحذف',
        noRecommend: 'لا توجد توصيات',
        apply: 'تطبيق',
        // MusicHistoryCard متعلق
        prompt: 'التلميح',
        noPrompt: 'لا يوجد تلميح',
        lyrics: 'كلمات الأغنية',
        noLyrics: 'لا توجد كلمات',
        downloadCover: 'تحميل الغلاف',
        downloadMusic: 'تحميل الموسيقى',
        untitledMusic: 'موسيقى بدون عنوان',
        noPlayableAudio: 'لا يوجد صوت قابل للتشغيل',
        noCopyContent: 'لا يوجد محتوى للنسخ',
        copyFailed: 'فشل النسخ',
        noDownloadableCover: 'لا يوجد غلاف قابل للتحميل',
        preparingDownload: 'جارٍ تحضير التحميل...',
        downloadRetry: 'فشل التحميل، يرجى المحاولة مرة أخرى',
        noDownloadableAudio: 'لا يوجد صوت قابل للتحميل',
        selectMaxVideo: 'حدد ما يصل إلى {count} مقاطع فيديو',
    },
    th: {
        batchGenerate: 'แบตช์หลายโมเดล',
        singleImgEdit: 'แก้ไขภาพเดี่ยว',
        all: 'ทั้งหมด',
        threeDays: '3 วันที่ผ่านมา',
        onWeek: 'สัปดาห์ที่ผ่านมา',
        oneMonth: 'เดือนที่ผ่านมา',
        time: 'เวลา',
        actions: 'ประเภทการทำงาน',
        IMAGE: 'ภาพ',
        VIDEO: 'วิดีโอ',
        AUDIO: 'เพลง',
        TOOL: 'เครื่องมือ',
        copySuccess: 'คัดลอกสำเร็จ',
        placeholderName: 'โปรดกรอกชื่อโปรเจกต์',
        addProject: 'เพิ่มโปรเจกต์',
        editProject: 'แก้ไขโปรเจกต์',
        confirm: 'ยืนยัน',
        cancel: 'ยกเลิก',
        deleteConfirmTitle: 'คุณแน่ใจหรือไม่ที่จะลบโปรเจกต์นี้?',
        deleteConfirmMessage:
            'บันทึกที่สร้างจะไม่ถูกเก็บไว้หลังจากลบ',
        publicVisibility: 'การแสดงแบบสาธารณะ',
        copyrightProtection: 'การป้องกันลิขสิทธิ์',
        publicVisibilityTooltip:
            'เมื่อเปิดตัวเลือกนี้ 微鲤AI อาจคัดเลือกผลงานของคุณและเผยแพร่ในไดเรกทอรีชุมชน',
        copyrightProtectionTooltip:
            'ปกป้องรูปภาพ วิดีโอ และพรอมป์ต์ที่อัปโหลดของคุณไม่ให้แสดงในชุมชน เมื่อเปิดใช้งาน ผู้ใช้ 微鲤AI คนอื่นจะไม่สามารถเห็นรูปภาพ วิดีโอ และพรอมป์ต์ที่คุณอัปโหลดเพื่อสร้างเนื้อหานี้ได้',
        select: 'เลือก',
        selectAll: 'เลือกทั้งหมด',
        delete: 'ลบ',
        download: 'ดาวน์โหลด',
        noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
        noImage: 'ไม่มีรูปภาพ',
        generateFailed: 'สร้างไม่สำเร็จ',
        selectMax: 'เลือกได้สูงสุด {count} รูป',
        regenerate: 'สร้างใหม่',
        selectModelLimitExceeded: 'เลือกได้สูงสุด {maxCount} โมเดล',
        batchGenerateTooltip:
            'เมื่อเปิดโหมดแบตช์ คุณสามารถเลือกหลายโมเดลเพื่อสร้างภาพพร้อมกัน จำนวนภาพที่ได้จะเท่ากับจำนวนภาพที่แต่ละโมเดลสร้าง เช่น เลือก 4 โมเดลและให้แต่ละโมเดลสร้าง 4 ภาพ ระบบจะสร้างภาพให้คุณ 16 ภาพในครั้งเดียว',
        pleaseWaiting: 'กำลังสร้าง...',
        allTime: 'ทุกช่วงเวลา',
        allType: 'ทุกประเภท',
        noImageSelected: 'โปรดเลือกรูปภาพ',
        downloading: 'กำลังดาวน์โหลด...',
        downloadFailed: 'ดาวน์โหลดล้มเหลว',
        downloadSuccess: 'ดาวน์โหลดสำเร็จ',
        downloadPartialSuccess:
            'ดาวน์โหลดบางส่วนสำเร็จ สำเร็จ {success} ล้มเหลว {total}',
        backToBottom: 'กลับไปด้านล่าง',
        standardMode: 'โหมดมาตรฐาน',
        standardDesc: 'กระบวนการสร้างภาพปกติ',
        batchMode: 'เปรียบเทียบโมเดล',
        batchGenerateDesc:
            'รองรับการเลือกหลายโมเดลเพื่อสร้าง พร้อมเปรียบเทียบผลของโมเดลต่างๆ ด้วยพารามิเตอร์เดียวกัน',
        singleMode: 'แบตช์หลายรูป',
        singleImgEditDesc:
            'ใช้พรอมป์ต์และการตั้งค่าปัจจุบันเพื่ออัปโหลดภาพอ้างอิงแบบแบตช์',
        singleImgReference: 'อ้างอิงภาพเดี่ยว',
        multiImgReference: 'อ้างอิงหลายภาพ',
        firstAndEndFrame: 'เฟรมแรกและสุดท้าย',
        firstFrame: 'เฟรมแรก',
        endFrame: 'เฟรมสุดท้าย',
        creativeDescription: 'คำอธิบายเชิงสร้างสรรค์',
        deleteSuccess: 'ลบสำเร็จ',
        deleteTitle:
            'การดำเนินการนี้จะลบไฟล์ {total} ไฟล์ถาวร คุณแน่ใจหรือไม่?',
        deleteCancel: 'ยกเลิก',
        deleteConfirm: 'ยืนยัน',
        deleteAll: 'ลบทั้งหมด',
        downloadAll: 'ดาวน์โหลดทั้งหมด',
        noContent: 'ไม่มีเนื้อหาให้ดาวน์โหลด',
        pleaseSelectImage: 'โปรดเลือกวัสดุที่จะลบ',
        pleaseChooseSame:
            'โปรดเลือกวัสดุที่จะลบในบันทึกเดียวกัน',
        confirmDelete: 'ยืนยันการลบ',
        noRecommend: 'ไม่มีรายการแนะนำ',
        apply: 'ใช้',
        // MusicHistoryCard related
        prompt: 'พรอมป์ต์',
        noPrompt: 'ไม่มีพรอมป์ต์',
        lyrics: 'เนื้อเพลง',
        noLyrics: 'ไม่มีเนื้อเพลง',
        downloadCover: 'ดาวน์โหลดหน้าปก',
        downloadMusic: 'ดาวน์โหลดเพลง',
        untitledMusic: 'เพลงไม่มีชื่อ',
        noPlayableAudio: 'ไม่มีเสียงที่เล่นได้',
        noCopyContent: 'ไม่มีเนื้อหาให้คัดลอก',
        copyFailed: 'คัดลอกล้มเหลว',
        noDownloadableCover: 'ไม่มีหน้าปกให้ดาวน์โหลด',
        preparingDownload: 'กำลังเตรียมดาวน์โหลด...',
        downloadRetry: 'ดาวน์โหลดล้มเหลว โปรดลองอีกครั้ง',
        noDownloadableAudio: 'ไม่มีเสียงให้ดาวน์โหลด',
        selectMaxVideo: 'เลือกวิดีโอได้สูงสุด {count} รายการ',
    },
    da: {
        batchGenerate: 'Batch i flere modeller',
        singleImgEdit: 'Rediger enkeltbillede',
        all: 'Alle',
        threeDays: 'Seneste 3 dage',
        onWeek: 'Seneste uge',
        oneMonth: 'Seneste måned',
        time: 'Tid',
        actions: 'Handlingstype',
        IMAGE: 'Billede',
        VIDEO: 'Video',
        AUDIO: 'Musik',
        TOOL: 'Værktøj',
        copySuccess: 'Kopieret',
        placeholderName: 'Indtast projektnavn',
        addProject: 'Tilføj projekt',
        editProject: 'Rediger projekt',
        confirm: 'Bekræft',
        cancel: 'Annuller',
        deleteConfirmTitle: 'Er du sikker på, at du vil slette dette projekt?',
        deleteConfirmMessage:
            'Genererede poster gemmes ikke efter sletning',
        publicVisibility: 'Offentlig synlighed',
        copyrightProtection: 'Ophavsretsbeskyttelse',
        publicVisibilityTooltip:
            'Når du aktiverer denne mulighed, kan 微鲤AI vælge dit arbejde og offentliggøre det i community‑kataloget.',
        copyrightProtectionTooltip:
            'Beskyt dine uploadede billeder, videoer og prompts mod at blive vist i communityet. Når dette er aktiveret, kan andre 微鲤AI‑brugere ikke se de billeder, videoer og prompts, du uploadede for at generere dette indhold i communityet.',
        select: 'Vælg',
        selectAll: 'Vælg alle',
        delete: 'Slet',
        download: 'Download',
        noMoreData: 'Ingen flere data',
        noImage: 'Intet billede',
        generateFailed: 'Generering mislykkedes',
        selectMax: 'Vælg op til {count} billeder',
        regenerate: 'Generér igen',
        selectModelLimitExceeded: 'Du kan vælge op til {maxCount} modeller',
        batchGenerateTooltip:
            'Ved at aktivere batch‑tilstand kan du vælge flere modeller og generere billeder samtidigt. Antal outputbilleder er antallet af billeder fra hver model; f.eks. 4 modeller × 4 billeder = 16 billeder i alt.',
        pleaseWaiting: 'Genererer...',
        allTime: 'Alle tider',
        allType: 'Alle typer',
        noImageSelected: 'Vælg billeder',
        downloading: 'Downloader...',
        downloadFailed: 'Download mislykkedes',
        downloadSuccess: 'Download fuldført',
        downloadPartialSuccess:
            'Delvis download: {success} succes, {total} fejlede',
        backToBottom: 'Tilbage til bunden',
        standardMode: 'Standardtilstand',
        standardDesc: 'Normal billedgenerering',
        batchMode: 'Model‑sammenligning',
        batchGenerateDesc:
            'Understøtter valg af flere modeller og sammenligner effekter med samme parametre',
        singleMode: 'Batch med flere billeder',
        singleImgEditDesc:
            'Brug nuværende prompt og indstillinger til at batch‑uploade referencebilleder',
        singleImgReference: 'Enkelt billedreference',
        multiImgReference: 'Flere billedreferencer',
        firstAndEndFrame: 'Første og sidste frame',
        firstFrame: 'Første frame',
        endFrame: 'Sidste frame',
        creativeDescription: 'Kreativ beskrivelse',
        deleteSuccess: 'Slettet',
        deleteTitle:
            'Denne handling sletter {total} filer permanent, er du sikker?',
        deleteCancel: 'Annuller',
        deleteConfirm: 'Bekræft',
        deleteAll: 'Slet alle',
        downloadAll: 'Download alle',
        noContent: 'Intet indhold at downloade',
        pleaseSelectImage: 'Vælg materialet, der skal slettes',
        pleaseChooseSame:
            'Vælg materialet, der skal slettes i samme post',
        confirmDelete: 'Bekræft sletning',
        noRecommend: 'Ingen anbefalinger',
        apply: 'Anvend',
        // MusicHistoryCard related
        prompt: 'Prompt',
        noPrompt: 'Ingen prompt',
        lyrics: 'Sangtekst',
        noLyrics: 'Ingen sangtekst',
        downloadCover: 'Download cover',
        downloadMusic: 'Download musik',
        untitledMusic: 'Musik uden titel',
        noPlayableAudio: 'Ingen afspilbar lyd',
        noCopyContent: 'Intet indhold at kopiere',
        copyFailed: 'Kopiering mislykkedes',
        noDownloadableCover: 'Intet cover til download',
        preparingDownload: 'Forbereder download...',
        downloadRetry: 'Download mislykkedes, prøv igen',
        noDownloadableAudio: 'Ingen lyd til download',
        selectMaxVideo: 'Vælg op til {count} videoer',
    },
    no: {
        batchGenerate: 'Fler‑modell‑batch',
        singleImgEdit: 'Rediger enkeltbilde',
        all: 'Alle',
        threeDays: 'Siste 3 dager',
        onWeek: 'Siste uke',
        oneMonth: 'Siste måned',
        time: 'Tid',
        actions: 'Handlingstype',
        IMAGE: 'Bilde',
        VIDEO: 'Video',
        AUDIO: 'Musikk',
        TOOL: 'Verktøy',
        copySuccess: 'Kopiert',
        placeholderName: 'Skriv inn prosjektnavn',
        addProject: 'Legg til prosjekt',
        editProject: 'Rediger prosjekt',
        confirm: 'Bekreft',
        cancel: 'Avbryt',
        deleteConfirmTitle: 'Er du sikker på at du vil slette dette prosjektet?',
        deleteConfirmMessage:
            'Genererte poster blir ikke beholdt etter sletting',
        publicVisibility: 'Offentlig synlighet',
        copyrightProtection: 'Opphavsrettsbeskyttelse',
        publicVisibilityTooltip:
            'Ved å aktivere dette kan 微鲤AI velge arbeidene dine og publisere dem i fellesskapskatalogen.',
        copyrightProtectionTooltip:
            'Beskytt opplastede bilder, videoer og prompts mot å bli vist i fellesskapet. Når dette er aktivert, kan andre 微鲤AI‑brukere ikke se bildene, videoene og promptene du lastet opp for å generere dette innholdet i fellesskapet.',
        select: 'Velg',
        selectAll: 'Velg alle',
        delete: 'Slett',
        download: 'Last ned',
        noMoreData: 'Ingen flere data',
        noImage: 'Ingen bilde',
        generateFailed: 'Generering mislyktes',
        selectMax: 'Velg opptil {count} bilder',
        regenerate: 'Generer på nytt',
        selectModelLimitExceeded: 'Du kan velge opptil {maxCount} modeller',
        batchGenerateTooltip:
            'Når batch‑modus er aktiv, kan du velge flere modeller og generere bilder samtidig. Antall bilder som lages er antall per modell; f.eks. 4 modeller × 4 bilder = 16 bilder totalt.',
        pleaseWaiting: 'Genererer...',
        allTime: 'Alle tider',
        allType: 'Alle typer',
        noImageSelected: 'Velg bilder',
        downloading: 'Laster ned...',
        downloadFailed: 'Nedlasting mislyktes',
        downloadSuccess: 'Nedlasting fullført',
        downloadPartialSuccess:
            'Delvis nedlasting: {success} vellykket, {total} feilet',
        backToBottom: 'Tilbake til bunnen',
        standardMode: 'Standardmodus',
        standardDesc: 'Vanlig bildegenerering',
        batchMode: 'Modell‑sammenligning',
        batchGenerateDesc:
            'Støtter valg av flere modeller og sammenligner effekter med samme parametre',
        singleMode: 'Batch med flere bilder',
        singleImgEditDesc:
            'Bruk nåværende prompt og innstillinger for å batch‑laste opp referansebilder',
        singleImgReference: 'Enkelt bilde‑referanse',
        multiImgReference: 'Flere bilde‑referanser',
        firstAndEndFrame: 'Første og siste frame',
        firstFrame: 'Første frame',
        endFrame: 'Siste frame',
        creativeDescription: 'Kreativ beskrivelse',
        deleteSuccess: 'Slettet',
        deleteTitle:
            'Denne handlingen vil slette {total} filer permanent, er du sikker?',
        deleteCancel: 'Avbryt',
        deleteConfirm: 'Bekreft',
        deleteAll: 'Slett alle',
        downloadAll: 'Last ned alle',
        noContent: 'Ingen innhold å laste ned',
        pleaseSelectImage: 'Velg materialet som skal slettes',
        pleaseChooseSame:
            'Velg materialet som skal slettes i samme oppføring',
        confirmDelete: 'Bekreft sletting',
        noRecommend: 'Ingen anbefalinger',
        apply: 'Bruk',
        // MusicHistoryCard related
        prompt: 'Prompt',
        noPrompt: 'Ingen prompt',
        lyrics: 'Tekst',
        noLyrics: 'Ingen tekst',
        downloadCover: 'Last ned cover',
        downloadMusic: 'Last ned musikk',
        untitledMusic: 'Musikk uten tittel',
        noPlayableAudio: 'Ingen spillbar lyd',
        noCopyContent: 'Ingen innhold å kopiere',
        copyFailed: 'Kopiering mislyktes',
        noDownloadableCover: 'Ingen cover å laste ned',
        preparingDownload: 'Forbereder nedlasting...',
        downloadRetry: 'Nedlasting mislyktes, prøv igjen',
        noDownloadableAudio: 'Ingen lyd å laste ned',
        selectMaxVideo: 'Velg opptil {count} videoer',
    },
    nl: {
        batchGenerate: 'Multi‑model batch',
        singleImgEdit: 'Enkele afbeelding bewerken',
        all: 'Alle',
        threeDays: 'Afgelopen 3 dagen',
        onWeek: 'Afgelopen week',
        oneMonth: 'Afgelopen maand',
        time: 'Tijd',
        actions: 'Actietype',
        IMAGE: 'Afbeelding',
        VIDEO: 'Video',
        AUDIO: 'Muziek',
        TOOL: 'Tool',
        copySuccess: 'Kopiëren gelukt',
        placeholderName: 'Voer de projectnaam in',
        addProject: 'Project toevoegen',
        editProject: 'Project bewerken',
        confirm: 'Bevestigen',
        cancel: 'Annuleren',
        deleteConfirmTitle: 'Weet je zeker dat je dit project wilt verwijderen?',
        deleteConfirmMessage:
            'Gegenereerde records worden niet bewaard na verwijdering',
        publicVisibility: 'Openbaarheid',
        copyrightProtection: 'Copyrightbescherming',
        publicVisibilityTooltip:
            'Door deze optie in te schakelen kan 微鲤AI je werk selecteren en publiceren in de community‑directory.',
        copyrightProtectionTooltip:
            'Bescherm je geüploade afbeeldingen, video\'s en prompts zodat ze niet in de community worden getoond. Als dit is ingeschakeld kunnen andere 微鲤AI‑gebruikers de afbeeldingen, video\'s en prompts die je hebt geüpload om deze content te genereren niet zien.',
        select: 'Selecteren',
        selectAll: 'Alles selecteren',
        delete: 'Verwijderen',
        download: 'Downloaden',
        noMoreData: 'Geen verdere data',
        noImage: 'Geen afbeelding',
        generateFailed: 'Genereren mislukt',
        selectMax: 'Selecteer maximaal {count} afbeeldingen',
        regenerate: 'Opnieuw genereren',
        selectModelLimitExceeded: 'Je kunt maximaal {maxCount} modellen selecteren',
        batchGenerateTooltip:
            'Door batch‑modus te activeren kun je meerdere modellen tegelijk laten genereren. Het aantal afbeeldingen is het aantal per model; bijvoorbeeld 4 modellen × 4 afbeeldingen = 16 afbeeldingen in één keer.',
        pleaseWaiting: 'Bezig met genereren...',
        allTime: 'Alle tijd',
        allType: 'Alle typen',
        noImageSelected: 'Selecteer afbeeldingen',
        downloading: 'Bezig met downloaden...',
        downloadFailed: 'Download mislukt',
        downloadSuccess: 'Download geslaagd',
        downloadPartialSuccess:
            'Gedeeltelijke download: {success} gelukt, {total} mislukt',
        backToBottom: 'Terug naar beneden',
        standardMode: 'Standaardmodus',
        standardDesc: 'Normale beeldgeneratie',
        batchMode: 'Modelvergelijking',
        batchGenerateDesc:
            'Ondersteunt het selecteren van meerdere modellen en het vergelijken van effecten met dezelfde parameters',
        singleMode: 'Batch met meerdere afbeeldingen',
        singleImgEditDesc:
            'Gebruik de huidige prompt en instellingen om referentieafbeeldingen batchgewijs te uploaden',
        singleImgReference: 'Enkele afbeeldingsreferentie',
        multiImgReference: 'Meerdere afbeeldingsreferentie',
        firstAndEndFrame: 'Eerste en laatste frame',
        firstFrame: 'Eerste frame',
        endFrame: 'Laatste frame',
        creativeDescription: 'Creatieve beschrijving',
        deleteSuccess: 'Verwijderd',
        deleteTitle:
            'Deze actie verwijdert {total} bestanden permanent, weet je het zeker?',
        deleteCancel: 'Annuleren',
        deleteConfirm: 'Bevestigen',
        deleteAll: 'Alles verwijderen',
        downloadAll: 'Alles downloaden',
        noContent: 'Geen content om te downloaden',
        pleaseSelectImage: 'Selecteer het materiaal om te verwijderen',
        pleaseChooseSame:
            'Selecteer het materiaal om te verwijderen in dezelfde record',
        confirmDelete: 'Verwijderen bevestigen',
        noRecommend: 'Geen aanbevelingen',
        apply: 'Toepassen',
        // MusicHistoryCard related
        prompt: 'Prompt',
        noPrompt: 'Geen prompt',
        lyrics: 'Songtekst',
        noLyrics: 'Geen songtekst',
        downloadCover: 'Cover downloaden',
        downloadMusic: 'Muziek downloaden',
        untitledMusic: 'Muziek zonder titel',
        noPlayableAudio: 'Geen afspeelbare audio',
        noCopyContent: 'Geen content om te kopiëren',
        copyFailed: 'Kopiëren mislukt',
        noDownloadableCover: 'Geen downloadbare cover',
        preparingDownload: 'Download voorbereiden...',
        downloadRetry: 'Download mislukt, probeer opnieuw',
        noDownloadableAudio: 'Geen downloadbare audio',
        selectMaxVideo: "Selecteer maximaal {count} video's",
    },
    id: {
        batchGenerate: 'Batch multi‑model',
        singleImgEdit: 'Edit gambar tunggal',
        all: 'Semua',
        threeDays: '3 hari terakhir',
        onWeek: 'Minggu lalu',
        oneMonth: 'Bulan lalu',
        time: 'Waktu',
        actions: 'Jenis aksi',
        IMAGE: 'Gambar',
        VIDEO: 'Video',
        AUDIO: 'Musik',
        TOOL: 'Alat',
        copySuccess: 'Berhasil menyalin',
        placeholderName: 'Masukkan nama proyek',
        addProject: 'Tambah proyek',
        editProject: 'Edit proyek',
        confirm: 'Konfirmasi',
        cancel: 'Batal',
        deleteConfirmTitle: 'Yakin ingin menghapus proyek ini?',
        deleteConfirmMessage:
            'Catatan yang dihasilkan tidak akan disimpan setelah dihapus',
        publicVisibility: 'Visibilitas publik',
        copyrightProtection: 'Perlindungan hak cipta',
        publicVisibilityTooltip:
            'Dengan mengaktifkan opsi ini, 微鲤AI dapat memilih karya Anda dan mempublikasikannya ke direktori komunitas.',
        copyrightProtectionTooltip:
            'Lindungi gambar, video, dan prompt yang Anda unggah agar tidak ditampilkan di komunitas. Jika diaktifkan, pengguna 微鲤AI lain tidak dapat melihat gambar, video, dan prompt yang Anda unggah untuk membuat konten ini di komunitas.',
        select: 'Pilih',
        selectAll: 'Pilih semua',
        delete: 'Hapus',
        download: 'Unduh',
        noMoreData: 'Tidak ada data lagi',
        noImage: 'Tidak ada gambar',
        generateFailed: 'Gagal menghasilkan',
        selectMax: 'Pilih hingga {count} gambar',
        regenerate: 'Buat ulang',
        selectModelLimitExceeded: 'Anda dapat memilih hingga {maxCount} model',
        batchGenerateTooltip:
            'Dengan mengaktifkan mode batch, Anda dapat memilih beberapa model untuk menghasilkan gambar secara bersamaan. Jumlah gambar yang dihasilkan adalah jumlah gambar dari tiap model; misalnya memilih 4 model dan tiap model menghasilkan 4 gambar, maka total 16 gambar sekaligus.',
        pleaseWaiting: 'Sedang menghasilkan...',
        allTime: 'Semua waktu',
        allType: 'Semua tipe',
        noImageSelected: 'Silakan pilih gambar',
        downloading: 'Mengunduh...',
        downloadFailed: 'Unduh gagal',
        downloadSuccess: 'Unduh berhasil',
        downloadPartialSuccess:
            'Unduh sebagian berhasil, {success} berhasil, {total} gagal',
        backToBottom: 'Kembali ke bawah',
        standardMode: 'Mode standar',
        standardDesc: 'Proses generasi gambar biasa',
        batchMode: 'Perbandingan model',
        batchGenerateDesc:
            'Mendukung memilih beberapa model untuk menghasilkan, membandingkan hasil model berbeda dengan parameter yang sama',
        singleMode: 'Batch multi‑gambar',
        singleImgEditDesc:
            'Gunakan prompt dan pengaturan saat ini untuk mengunggah gambar referensi secara batch',
        singleImgReference: 'Referensi gambar tunggal',
        multiImgReference: 'Referensi multi gambar',
        firstAndEndFrame: 'Frame awal dan akhir',
        firstFrame: 'Frame awal',
        endFrame: 'Frame akhir',
        creativeDescription: 'Deskripsi kreatif',
        deleteSuccess: 'Berhasil dihapus',
        deleteTitle:
            'Operasi ini akan menghapus {total} file secara permanen, yakin?',
        deleteCancel: 'Batal',
        deleteConfirm: 'Konfirmasi',
        deleteAll: 'Hapus semua',
        downloadAll: 'Unduh semua',
        noContent: 'Tidak ada konten untuk diunduh',
        pleaseSelectImage: 'Silakan pilih materi yang akan dihapus',
        pleaseChooseSame:
            'Silakan pilih materi yang akan dihapus dalam catatan yang sama',
        confirmDelete: 'Konfirmasi hapus',
        noRecommend: 'Tidak ada rekomendasi',
        apply: 'Terapkan',
        // MusicHistoryCard related
        prompt: 'Prompt',
        noPrompt: 'Tidak ada prompt',
        lyrics: 'Lirik',
        noLyrics: 'Tidak ada lirik',
        downloadCover: 'Unduh sampul',
        downloadMusic: 'Unduh musik',
        untitledMusic: 'Musik tanpa judul',
        noPlayableAudio: 'Tidak ada audio yang dapat diputar',
        noCopyContent: 'Tidak ada konten untuk disalin',
        copyFailed: 'Gagal menyalin',
        noDownloadableCover: 'Tidak ada sampul yang dapat diunduh',
        preparingDownload: 'Menyiapkan unduhan...',
        downloadRetry: 'Unduh gagal, silakan coba lagi',
        noDownloadableAudio: 'Tidak ada audio yang dapat diunduh',
        selectMaxVideo: 'Pilih hingga {count} video',
    },
    tr: {
        batchGenerate: 'Çoklu model toplu',
        singleImgEdit: 'Tek görsel düzenleme',
        all: 'Tümü',
        threeDays: 'Son 3 gün',
        onWeek: 'Son hafta',
        oneMonth: 'Son ay',
        time: 'Zaman',
        actions: 'İşlem türü',
        IMAGE: 'Görsel',
        VIDEO: 'Video',
        AUDIO: 'Müzik',
        TOOL: 'Araç',
        copySuccess: 'Kopyalama başarılı',
        placeholderName: 'Lütfen proje adını girin',
        addProject: 'Proje ekle',
        editProject: 'Projeyi düzenle',
        confirm: 'Onayla',
        cancel: 'İptal',
        deleteConfirmTitle: 'Bu projeyi silmek istediğinize emin misiniz?',
        deleteConfirmMessage:
            'Silme sonrası oluşturulan kayıtlar tutulmaz',
        publicVisibility: 'Genel görünürlük',
        copyrightProtection: 'Telif hakkı koruması',
        publicVisibilityTooltip:
            'Bu seçeneği etkinleştirirseniz 微鲤AI çalışmanızı seçip topluluk dizininde yayınlayabilir.',
        copyrightProtectionTooltip:
            'Yüklediğiniz görsellerin, videoların ve promptların toplulukta görünmesini engeller. Etkinleştirildiğinde diğer 微鲤AI kullanıcıları bu içeriği oluşturmak için yüklediğiniz görselleri, videoları ve promptları göremez.',
        select: 'Seç',
        selectAll: 'Tümünü seç',
        delete: 'Sil',
        download: 'İndir',
        noMoreData: 'Daha fazla veri yok',
        noImage: 'Görsel yok',
        generateFailed: 'Oluşturma başarısız',
        selectMax: 'En fazla {count} görsel seçin',
        regenerate: 'Yeniden oluştur',
        selectModelLimitExceeded: 'En fazla {maxCount} model seçebilirsiniz',
        batchGenerateTooltip:
            'Batch modu etkinleştirildiğinde birden fazla modeli aynı anda seçip görsel üretebilirsiniz. Üretilen görsel sayısı, her modelin ürettiği görsel sayısına eşittir; örn. 4 model × 4 görsel = toplam 16 görsel.',
        pleaseWaiting: 'Oluşturuluyor...',
        allTime: 'Tüm zamanlar',
        allType: 'Tüm türler',
        noImageSelected: 'Lütfen görsel seçin',
        downloading: 'İndiriliyor...',
        downloadFailed: 'İndirme başarısız',
        downloadSuccess: 'İndirme başarılı',
        downloadPartialSuccess:
            'Kısmi indirme başarılı: {success} başarılı, {total} başarısız',
        backToBottom: 'En alta dön',
        standardMode: 'Standart mod',
        standardDesc: 'Normal görsel üretim süreci',
        batchMode: 'Model karşılaştırma',
        batchGenerateDesc:
            'Birden çok model seçerek aynı parametrelerle farklı modellerin sonuçlarını karşılaştırmayı destekler',
        singleMode: 'Çoklu görsel toplu',
        singleImgEditDesc:
            'Mevcut prompt ve ayarlarla referans görselleri toplu yükleyin',
        singleImgReference: 'Tek görsel referansı',
        multiImgReference: 'Çoklu görsel referansı',
        firstAndEndFrame: 'İlk ve son kare',
        firstFrame: 'İlk kare',
        endFrame: 'Son kare',
        creativeDescription: 'Yaratıcı açıklama',
        deleteSuccess: 'Silme başarılı',
        deleteTitle:
            'Bu işlem {total} dosyayı kalıcı olarak siler, emin misiniz?',
        deleteCancel: 'İptal',
        deleteConfirm: 'Onayla',
        deleteAll: 'Tümünü sil',
        downloadAll: 'Tümünü indir',
        noContent: 'İndirilecek içerik yok',
        pleaseSelectImage: 'Lütfen silinecek materyali seçin',
        pleaseChooseSame:
            'Lütfen aynı kayıttaki silinecek materyali seçin',
        confirmDelete: 'Silmeyi onayla',
        noRecommend: 'Öneri bulunamadı',
        apply: 'Uygula',
        // MusicHistoryCard related
        prompt: 'Prompt',
        noPrompt: 'Prompt yok',
        lyrics: 'Şarkı sözleri',
        noLyrics: 'Söz yok',
        downloadCover: 'Kapak indir',
        downloadMusic: 'Müzik indir',
        untitledMusic: 'Başlıksız müzik',
        noPlayableAudio: 'Çalınabilir ses yok',
        noCopyContent: 'Kopyalanacak içerik yok',
        copyFailed: 'Kopyalama başarısız',
        noDownloadableCover: 'İndirilebilir kapak yok',
        preparingDownload: 'İndirme hazırlanıyor...',
        downloadRetry: 'İndirme başarısız, lütfen tekrar deneyin',
        noDownloadableAudio: 'İndirilebilir ses yok',
        selectMaxVideo: 'En fazla {count} video seçin',
    },
}
